import * as React from "react"
import { type Transaction } from "@digits-graphql/frontend/graphql-bearer"
import { LoadingCircle } from "@digits-shared/components/Loaders"
import { ColorIcon } from "@digits-shared/components/UI/Elements/ColorIcon"
import { IconSize } from "@digits-shared/components/UI/Icons/Icon"
import { hasFirstElement } from "@digits-shared/helpers/arrayHelper"
import styled from "styled-components"

const SourceFieldContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;

  *:not(:first-child) {
    margin-left: -10px;
  }
`

export const SourceCell: React.FC<{
  transaction: Transaction
}> = ({ transaction: { sources } }) => {
  if (!hasFirstElement(sources)) return null

  return (
    <SourceFieldContainer>
      {sources.map(({ iconUrl, name }, idx) => (
        <ColorIcon
          key={`${iconUrl}${name}${idx}`}
          imageUrl={iconUrl}
          size={IconSize.SmallMedium.pixels}
          fallbackText={name}
        />
      ))}
    </SourceFieldContainer>
  )
}

export const LoadingSourceCell: React.FC = () => (
  <SourceFieldContainer>
    <LoadingCircle width={IconSize.SmallMedium.pixels} height={IconSize.SmallMedium.pixels ?? 0} />
  </SourceFieldContainer>
)
